import { UserProfileGroupType } from "../../container/Contact/Imported/UserProfileGroupType";
import { get } from "../apiRequest";
import { GET_USER_PROFILES_LIST } from "../apiPath";

interface UserGroupsResponse {
  userGroups: UserProfileGroupType[];
}

export async function fetchUserGroups(
  params: { limit: number; offset: number } = { limit: 500, offset: 0 }
): Promise<UserGroupsResponse> {
  return await get(GET_USER_PROFILES_LIST, {
    param: params,
  });
}
